import React from 'react';
import { useSelector } from 'react-redux';
import './MediaControls.scss';

import PlayButton from '../../../assets/images/buttons/btn_video-play_small.png';
import PauseButton from '../../../assets/images/buttons/btn_video-pause.png';
import NextButton from '../../../assets/images/buttons/btn_video-next.png';
import MutedButton from '../../../assets/images/buttons/btn_video-mute.png';
import MuteButton from '../../../assets/images/buttons/btn_video-volume.png';
import MinimizeButton from '../../../assets/images/buttons/btn_video-minimize.png';

const MediaControls = props => {

  const menuOpened = useSelector(state => state.data.menuOpened);

  var sliderInnerStyle = {
    width: props.progress * 100 + '%',
    transition: props.updateInterval + 'ms'
  };

  const handleSliderClicked = data => {
    if (data && data.target) {
      var scrubBounds = data.target.getBoundingClientRect();
      var x = data.pageX - scrubBounds.left;
      var width = scrubBounds.width;
      props.onScrub(x / width);
    }
  };

  const handlePlayClicked = data => {
    props.onPlay();
  };

  const handleVolumeClicked = data => {
    props.onMute();
  };

  const handleMinimize = data => {
    props.onMinimize();
  };

  function getTimestamp() {
    var cur = toHHMMSS(props.progress * props.duration);
    var dur = toHHMMSS(props.duration);
    return (
      <>
        {cur}/{dur}
      </>
    );
  }

  function toHHMMSS(secs) {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map(v => (v < 10 ? '0' + v : v))
      .filter((v, i) => v !== '00' || i > 0)
      .join(':');
  }

  return (
    <div className="controls">
      {props.captions}
      <div className="controls-slider-outer">
        <div className="controls-slider-inner" style={sliderInnerStyle} />
        <div className="controls-slider-touch-area" onClick={handleSliderClicked} />
      </div>
      <div className="controls-menu">
        <img
          className="play-button"
          src={props.playing ? PauseButton : PlayButton}
          tabIndex={!menuOpened ? 0 : -1}
          alt="Play/Pause Button"
          onKeyPress={handlePlayClicked}
          onClick={handlePlayClicked}
        />
        {/* <img className="next-button" src={NextButton} alt="Next Button" onClick={handleMinimize} /> */}
        <div className="timestamp">{getTimestamp()}</div>
        <img
          className="mute-button"
          src={props.muted ? MutedButton : MuteButton}
          alt="Volume Button"
          tabIndex={!menuOpened ? 0 : -1}
          onKeyPress={handleVolumeClicked}
          onClick={handleVolumeClicked}
        />
        {/* <img
          className="minimize-button"
          src={MinimizeButton}
          alt="Minimize Button"
          onClick={handleMinimize}
        /> */}
      </div>
    </div>
  );
};

export default MediaControls;
